import axios from 'axios';
import {
  MDBAlert,
  MDBBadge,
  MDBBtn,
  MDBBtnGroup,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBChip,
  MDBCol,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow,
  MDBSpinner,
  MDBTable,
  MDBTableBody, MDBTypography
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CartContext } from '../context/CartProvider';
import { CategoryContext } from '../context/CategoryContext';
import { DomainContext } from '../context/DomainProvider';
import { GeographyContext } from '../context/GeographyProvider';
import { MiscContext } from '../context/MiscProvider';
import { NavbarContext } from '../context/NavProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import Inventory from '../inventory/Inventory';
import LoginModal from '../login/LoginModal';
import UserMessagesModal from '../messages/UserMessagesModal';
import { fetchMainPageData } from '../utils/Common';
import NoOrders from './NoOrders';
const Orders = ({ groupedItems }) => {

  const { fromCheckout } = useParams();

  
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { setAlertMessage ,setShowAlert} = useContext(MiscContext);
  const {categoryImages} = useContext(CategoryContext);
  const {domainImages} = useContext(DomainContext);
  const {location, ipAddress} = useContext(GeographyContext);
  const {  avatar,isPricing, setIsPricing,pageData,setPageData,setBusiness} = useContext(NavbarContext);
  const { cartCount,setCartId, setCart,setAddedEntities, setCartCount,orders, setOrders } = useContext(CartContext);
  const {uid, setUid,tokenLoaded} = useContext(UserProfileContext);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const [userCreationWithCheckout, setUserCreationWithCheckout] = useState(true);
  const [cancelled, setCancelled] = useState(false);
  const [userMessage, setUserMessage] = useState(orders?.[0]?.userMessages);
 
  const toggleUserCreatedOnCheckout = () => setUserCreationWithCheckout(!userCreationWithCheckout);
  const fetchItems = useCallback(async () => {
    try {

      let latLngQuery = "";
      if (location) {
        console.log(`Latitude: ${location.latitude}, Longitude: ${location.longitude}`);
        latLngQuery = `?latitude=${location.latitude}&longitude=${location.longitude}`;
      } else {
        latLngQuery = `?ipAddress=${ipAddress}`;
      }
      let url = `${baseUrl}/orders`;
      url = url + latLngQuery;

      const response = await axios.get(url);

      if (response.data.length > 0) {
        setOrders(response.data);
        setUserMessage(response.data?.[0].userMessages);
      } else {
        navigate('/no-orders');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [setOrders,tokenLoaded]);

  useEffect(() => {
    if (!pageData) {
      fetchMainPageData(setPageData,setIsPricing,pageData,setBusiness);
      
    }
  }, []);

  useEffect(() => {
    tokenLoaded ? fetchItems() : setIsLoading(false);
  }, [fetchItems, tokenLoaded]);


  const handleOrderToCapture = (orderId) => {
    setUserMessage(null);
    axios
      .get(`${baseUrl}/orders/anonymous/${orderId}`)
      .then((response) => {
        // Filter out the order with the given orderId


        if (!response.data?.status || response.data?.status !== 'Failed') {
          setUserCreationWithCheckout(true);
          // setOrders(response.data);
          setAddedEntities([]);
          setCartCount(0);
          setCart(null);
          setCartId(null);
          setUid(response.data?.createdBy);
          localStorage.removeItem('CART-ID');


        }
        setUserMessage([response.data.message]);
setShowAlert(true);
      
      })
      .catch((error) => {
        setUserMessage(['ERROR_DURING_TRANSACTION']);
        console.error(error);
        // Handle the error as you see fit
      });
  };

  
  // const [visibleAlerts, setVisibleAlerts] = useState(userMessage.map(() => true));

  // useEffect(() => {
  //   const timeouts = userMessage.map((_, index) => {
  //     return setTimeout(() => {
  //       setVisibleAlerts((prevVisibleAlerts) => {
  //         const newVisibleAlerts = [...prevVisibleAlerts];
  //         newVisibleAlerts[index] = false;
  //         return newVisibleAlerts;
  //       });
  //     }, 10000);
  //   });

  //   // Clear timeouts if the component unmounts
  //   return () => {
  //     timeouts.forEach((timeout) => clearTimeout(timeout));
  //   };
  // }, [userMessage]);

  const handleWholeOrderDelete = (orderId) => {
  //  (cancelled && isPricing) ? navigate('/products/pricing') : cancelled && navigate('/products');
    axios
      .delete(`${baseUrl}/orders/anonymous/${orderId}`)
      .then((response) => {
        const updatedOrders = orders?.filter(order => !order.orders?.hasOwnProperty(orderId));
           if(updatedOrders.length <=1){
        setOrders(updatedOrders);
        }
        setAddedEntities([]);
        setCartCount(0);
        setCart(null);
        setCartId(null);
        localStorage.removeItem('CART-ID');
        setCancelled(true);
        setUserMessage([response.data.message]);
        setAlertMessage(response.data.message);
        setShowAlert(response.data.status === 'CANCELLED' || (response.data.status === 'Failed'))
        isPricing ? navigate('/shop/pricing') :  navigate('/products');      
      })
      .catch((error) => {
        console.error(error);
        // Handle the error as you see fit
      });
  };



  const handleDelete = (orderId, entityId) => {
    axios
      .put(`${baseUrl}/orders/${orderId}/entity/${entityId}`)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          setOrders(response.data);
        } else if (response.status === 404) {
          setOrders(null);
isPricing ? navigate('/shop/pricing') : navigate('/shop');
        }
      })
      .catch((error) => {
        fetchItems();
        console.error(error);
      });
  };
  const [isUpdateButtonClicked, setIsUpdateButtonClicked] = useState(false);

  const handleUpdateButtonClick = () => {
    setIsUpdateButtonClicked(true);
  };
  useEffect(() => {
    if (isUpdateButtonClicked) {
      setIsUpdateButtonClicked(false);
    }
  }, [isUpdateButtonClicked]);


  const [requestModal, setRequestModal] = useState(false);
  const [currentRequestId, setCurrentRequestId] = useState(null);



  const toggleUpdateRequestModal = () => {
    window.scrollTo(0, 0); // Scrolls to top
    setRequestModal((prevState) => !prevState);
  };

  return (

    isLoading ? (
      <div className='d-flex m-5 justify-content-center' >
        <MDBSpinner style={{ width: '6rem', height: '6rem' }}>
          <span className='visually-hidden'>Loading...</span>
        </MDBSpinner>
      </div>
    ) :
      (orders?.length > 0 ?
        <section className='grainy-gradient-intro'>
        {fromCheckout && <UserMessagesModal status={orders[0]?.status} messages={userMessage || []} />}
        {!tokenLoaded && uid && (
          <MDBModal animationDirection='bottom' open={userCreationWithCheckout} setOpen={setUserCreationWithCheckout} onClose={() => setUserCreationWithCheckout(false)}>
            <MDBModalDialog position='bottom' frame background='transparent'>
              <MDBModalContent>
                <MDBModalBody className='py-1'>
                  <div className='d-flex justify-content-center align-items-center my-3 '>
                    <MDBTypography className='lead mb-0 listUnStyled'>
                      <li className='mb-1' style={{ listStyleType: 'none' }}>
                        <MDBIcon far icon="thumbs-up" className='me-2 text-success drop-out' size='2x' />
                        Thanks for Ordering, Here is your UserId <strong className='fs-2'>{uid}</strong> to login into your account.. <LoginModal anonymousUser={uid} />
                      </li>
                    </MDBTypography>
                    <MDBBtn floating size='lg' tag='a' color='none' className='ms-2 mt-1' onClick={() => setUserCreationWithCheckout(false)}>
                      <MDBIcon size='2x' far icon="check-circle" style={{ color: '#3b5998' }} />
                    </MDBBtn>
                  </div>
                </MDBModalBody>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        )}
        {orders[0]?.userName && (
          <section className='mt-2'>
            <MDBModalTitle className='text-center'>{cartCount !== 0 && ' Review the order'}</MDBModalTitle>
            <MDBRow className='row-cols-1 row-cols-md-2 d-flex justify-content-center'>
              {!isLoading && orders.map((order, index) => {
                const { orders: ords, createdBy, userName, lastUpdated, domainImage, domainName } = order;
                let totalCount = 0;
                Object.values(ords || {}).forEach(categories => {
                  Object.values(categories).forEach(items => {
                    totalCount += items.length;
                  });
                });
      
                return Object.entries(ords || {}).map(([orderId, categories]) => (
                  <MDBCol key={orderId} xs='12' sm='6' md='6' lg={orders.length === 1 ? 6 : 4} className='mb-2 ms-2'>
                    {isPricing ? (
                      <MDBCard className='d-flex flex-column justify-content-center align-items-center mb-2'>
                        <span style={{ position: 'absolute', top: 10, right: 10 }}>
                          <MDBBadge color='success' light pill className='position-absolute translate-middle text-primary'>
                            {totalCount}
                          </MDBBadge>
                        </span>
                        <div className='position-relative d-inline-block'>
                          {domainImage && (
                            <MDBCardImage
                              src={domainImage}
                              alt='...'
                              position='top'
                              className='mb-3 img-thumbnail'
                              style={{ width: '400px', height: '300px' }}
                              fluid
                            />
                          )}
                        </div>
                        <MDBCardTitle>
                          <MDBChip className='mx-5 '>
                            {(avatar !== 'undefined') && <img src={avatar || 'https://opengrit.com/images/viabootcamp'} alt={userName} />}
                            <span className='text-wrap text-capitalize fw-bold fs-6 d-inline-block text-truncate text-success text-center' style={{ maxWidth: 150 }}>{createdBy}</span>
                          </MDBChip>
                        </MDBCardTitle>
                        <MDBCardBody>
                          {Object.entries(categories).map(([category, items]) => (
                            <MDBTable key={category} align="middle" bordered striped>
                              <MDBTableBody className='d-flex align-items-center text-center'>
                                {items.map((item, index) => (
                                  <tr key={index} className='d-flex align-items-center flex-wrap d-inline-block text-center'>
                                    <td>
                                      <h2 className="h1-responsive font-weight-bold text-center">
                                        {item.name} : ${item.totalPrice}
                                      </h2>
                                    </td>
                                  </tr>
                                ))}
                              </MDBTableBody>
                            </MDBTable>
                          ))}
                        </MDBCardBody>
      
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                          <MDBCard className='text-center rounded'>
                            <MDBTable align="middle" bordered striped>
                              <MDBTableBody>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Total Amount</th>
                                  <td>${order.totalAmount}</td>
                                </tr>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Total Sales Tax</th>
                                  <td>${order.totalSalesTax}</td>
                                </tr>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Grand Total</th>
                                  <td>${order.grandTotal}</td>
                                </tr>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Email</th>
                                  <td>
                                    <MDBIcon far icon="envelope" className='me-1' />
                                    {order.email}
                                  </td>
                                </tr>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Phone</th>
                                  <td>
                                    <MDBIcon fas icon="phone" className='me-1' />
                                    {order.phone}
                                  </td>
                                </tr>
                              </MDBTableBody>
                            </MDBTable>
                          </MDBCard>
                        </div>
      
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                          {order.status !== 'AUTHORIZED' && userMessage?.map((message, index) => (
                            <MDBAlert key={index} open className='w-75 d-flex' color={order.status === 'AUTHORIZED' ? 'primary' : 'danger'} autohide delay={10000}>
                              <i className="fas fa-check-circle me-3"></i>{message}
                            </MDBAlert>
                          ))}
                          <MDBBtnGroup className='mb-2  mt-2'>
                          {cartCount > 0 && (
                            <MDBBtn
                              color='warning'
                              onClick={() => {
                                setCartId(order.id);
                                navigate('/cart');
                              }}
                              className="responsive-button"
                            >
                              Update
                            </MDBBtn>
                          )}
                          <MDBBtn
                            color='primary'
                            onClick={() => handleWholeOrderDelete(orderId)}
                            className=" responsive-button"
                          >
                            {cancelled ? 'SHOP' : 'cancel'}
                          </MDBBtn>
                          </MDBBtnGroup>
                          <MDBChip color='light' className='justify-content-center'></MDBChip>
                          <small className='text-muted mb-2'>{lastUpdated}</small>
                        </div>
                      </MDBCard>
                    ) : (
                      <MDBCard key={orderId} className='d-flex flex-column justify-content-center align-items-center ms-2'>
                        <span style={{ position: 'absolute', top: 10, right: 10 }}>
                          <MDBBadge color='success' light pill className='position-absolute translate-middle text-primary'>
                            {totalCount}
                          </MDBBadge>
                        </span>
                        <div className='position-relative d-inline-block'>
                          {domainImage && <MDBCardImage src={domainImage} alt='...' position='top' className='mb-3 img-thumbnail rounded' style={{ width: '400px', height: '300px' }} fluid />}
                        </div>
                        <MDBCardTitle>
                          <MDBChip className='mx-5 mt-4' color='success'>
                            <span className='text-wrap text-capitalize fw-bold fs-6 d-inline-block text-truncate text-success' style={{ maxWidth: 150 }}>{userName}</span>
                            <span className='ms-2 text-wrap text-primary'><span className='text-warning fw-bold'>Order #: </span> {order.id}</span>
                          </MDBChip>
                        </MDBCardTitle>
                        <MDBCardBody>
                          {Object.entries(categories).map(([category, items]) => (
                            <div key={category}>
                              {categoryImages && <img src={categoryImages && categoryImages[category]} alt="" style={{ width: '30px', height: '30px', marginRight: '10px' }} className="rounded" />}
                              <a href='#!'>
                                <MDBBadge color='light' light className='text-capitalize'>
                                  <h6 style={{ color: 'red' }}>{category}</h6>
                                </MDBBadge>
                                <MDBBadge color='primary' notification pill>
                                  {items.length}
                                </MDBBadge>
                              </a>
                              <MDBTable>
                                <MDBTableBody>
                                  {items.map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        <div className='d-flex align-items-center flex-wrap d-inline-block'>
                                          <img src={item.thumbnails && item.thumbnails[0]} alt='' className='rounded img-fluid d-inline-block' style={{ width: '30px', height: '30px' }} />
                                          <div className='ms-2 text-capitalize'><span className='text-primary ms-2'>{item.name}</span><span className='fw-bold'>{item.totalPrice}</span></div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </MDBTableBody>
                              </MDBTable>
                            </div>
                          ))}
                        </MDBCardBody>
      
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                          <MDBCard className='text-center rounded'>
                            <MDBTable align="middle" bordered striped>
                              <MDBTableBody>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Total Amount</th>
                                  <td>${order.totalAmount}</td>
                                </tr>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Total Sales Tax</th>
                                  <td>${order.totalSalesTax}</td>
                                </tr>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Grand Total</th>
                                  <td>${order.grandTotal}</td>
                                </tr>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Total Weight In Kgs</th>
                                  <td>${order.totalWeightInKgs}</td>
                                </tr>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Total Weight In lbs</th>
                                  <td>${order.totalWeightInLbs}</td>
                                </tr>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Email</th>
                                  <td>
                                    <MDBIcon far icon="envelope" className='me-1' />
                                    <small className='ms-1 text-wrap text-primary'>{order.email}</small>
                                  </td>
                                </tr>
                                <tr>
                                  <th style={{ textAlign: 'left' }}>Phone</th>
                                  <td>
                                    <MDBIcon fas icon="phone" className='me-1' />
                                    <small className='ms-1 text-primary'>{order.phone}</small>
                                  </td>
                                </tr>
                              </MDBTableBody>
                            </MDBTable>
                          </MDBCard>
                        </div>
      
                        <hr className="hr hr-blurry text-primary" />
      
                        <MDBCard className='mb-4'>
                          <MDBCardBody>
                            <MDBRow className='justify-content-center text-success'>
                              {order.addresses['Billing']?.id === order.addresses['Shipping']?.id ? (
                                <MDBCol size='12' className="bg-light border d-flex flex-column align-items-center p-3">
                                  <h5 className='text-center'>Billing and Shipping <MDBIcon far icon="address-card" /></h5>
                                  <hr className="hr hr-blurry" />
                                  <div className="text-center">
                                    <p className="mb-1">{order.addresses['Billing']?.firstName} {order.addresses['Billing']?.lastName}</p>
                                    <p className="mb-1">{order.addresses['Billing']?.street}</p>
                                    <p className="mb-1">{order.addresses['Billing']?.locality}</p>
                                    <p className="mb-1">{order.addresses['Billing']?.stateOrProvince} - {order.addresses['Billing']?.postalCode} {order.addresses['Billing']?.countryName}</p>
                                  </div>
                                </MDBCol>
                              ) : (
                                <>
                                  <MDBCol md="6" className="bg-light border d-flex flex-column align-items-center p-3">
                                    <h5 className='text-center'>Billing Address <MDBIcon far icon="address-card" /></h5>
                                    <hr className="hr hr-blurry" />
                                    <div className="text-center">
                                      <p className="mb-1">{order.addresses['Billing']?.firstName} {order.addresses['Billing']?.lastName}</p>
                                      <p className="mb-1">{order.addresses['Billing']?.street}</p>
                                      <p className="mb-1">{order.addresses['Billing']?.locality}</p>
                                      <p className="mb-1">{order.addresses['Billing']?.stateOrProvince} - {order.addresses['Billing']?.postalCode} {order.addresses['Billing']?.countryName}</p>
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="6" className="bg-light border d-flex flex-column align-items-center p-3">
                                    <h5 className='text-center'>Shipping Address <MDBIcon fas icon="truck" /></h5>
                                    <hr className="hr hr-blurry" />
                                    <div className="text-center">
                                      <p className="mb-1">{order.addresses['Shipping']?.firstName} {order.addresses['Shipping']?.lastName}</p>
                                      <p className="mb-1">{order.addresses['Shipping']?.street}</p>
                                      <p className="mb-1">{order.addresses['Shipping']?.locality}</p>
                                      <p className="mb-1">{order.addresses['Shipping']?.stateOrProvince} - {order.addresses['Shipping']?.postalCode} {order.addresses['Shipping']?.countryName}</p>
                                    </div>
                                  </MDBCol>
                                </>
                              )}
                            </MDBRow>
                          </MDBCardBody>
                        </MDBCard>
      
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                          {order.status !== 'AUTHORIZED' && userMessage?.map((message, index) => (
                            <MDBAlert key={index} open={userMessage.length > 0} className='w-75 d-flex' color={order.status === 'AUTHORIZED' ? 'secondary' : 'danger'} autohide={true} delay={10000}>
                              <i className="fas fa-check-circle me-3"></i>{message}
                            </MDBAlert>
                          ))}
                          <MDBBtnGroup>
                          {cartCount > 0 && (
                            <MDBBtn
                              color='warning'
                              onClick={() => {
                                setCartId(order.id);
                                navigate('/cart');
                              }}
                              className="responsive-button"
                            >
                              Update
                            </MDBBtn>
                          )}
                          <MDBBtn color='primary' onClick={() => handleWholeOrderDelete(orderId)} className=" responsive-button">
                            {cancelled ? 'SHOP' : 'cancel'}
                          </MDBBtn>
                          {cartCount > 0 && order.status !== 'AUTHORIZED' && (
                            <MDBBtn
                              color='dark'
                              onClick={() => handleOrderToCapture(orderId)}
                              className="mb-4 me-1 responsive-button"
                              disabled={
                                order?.userMessages.includes("ERROR_DURING_CANCELLATION") ||
                                order?.userMessages.includes("ERROR_DURING_AUTHORIZATION") ||
                                order?.userMessages.includes("ERROR_DURING_CREDIT_CARD_PROCESS")
                              }
                            >
                              confirm
                            </MDBBtn>
                          )}
                          </MDBBtnGroup>
                          <MDBChip color='light' className='justify-content-center'>
                            <MDBTypography id="squareIcon" className='mb-0 ms-2'>
                              <small>Delivery: {order.deliveryDate}</small>
                            </MDBTypography>
                          </MDBChip>
                          <small className='text-muted'>{lastUpdated}</small>
                        </div>
                      </MDBCard>
                    )}
                  </MDBCol>
                ));
              })}
            </MDBRow>
            {requestModal && (
              <MDBModal tabIndex={-1} open={requestModal} setOpen={toggleUpdateRequestModal} nonInvasive={true}>
                <MDBModalHeader toggle={toggleUpdateRequestModal}>
                  <MDBBtn
                    className='btn-close'
                    color='none'
                    onClick={toggleUpdateRequestModal}
                  ></MDBBtn>
                </MDBModalHeader>
                <MDBModalDialog size='xl'>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Add Items to existing request</MDBModalTitle>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <Inventory toggleUpdateRequestModal={toggleUpdateRequestModal} isRequestUpdate={true} groupedItems={groupedItems} domainImages={domainImages} categoryImages={categoryImages} requestId={currentRequestId} />
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            )}
          </section>
        )}
      </section>
       : <NoOrders/>

      )
  );
}

Orders.propTypes = {
  groupedItems: PropTypes.array,
};

export default Orders;
